angular.module('bmsApp.crm.customer').controller('CustomerMapActiveJobsCtrl', function ($scope,
																						$q,
																						$timeout,
																						$state,
																						$filter,
																						CustomerSvc,
																						GeocodeSvc,
																						uiGmapGoogleMapApi,
																						uiGmapIsReady) {

	$scope.loading = true;
	$scope.siteMarkers = [];
	$scope.customers = [];
	$scope.control = {};
	$scope.markers = {
		events: {
			click: function (evt) {
				// find clicked customer
				var siteId = evt.model.id;
				var customers = $filter('filter')($scope.customers, {
					primary_site: {
						id: siteId
					}
				}, true);
				if (angular.isArray(customers)) {
					angular.forEach(customers, function(customer) {
						$scope.recordClick(customer);
					});
				}
			}
		}
	};

	$scope.isNumber = angular.isNumber;

	uiGmapIsReady.promise().then(function () {
		CustomerSvc.activeJobs().then(function (response) {
			var map = $scope.control.getGMap();
			var customers = response.data.customer_collection;
			var bounds = new google.maps.LatLngBounds();
			// Put the markers into a custom object for google maps
			angular.forEach(customers, function (customer) {
				if (angular.isObject(customer.primary_site) && angular.isNumber(customer.primary_site.lat) && angular.isNumber(customer.primary_site.lng)) {
					$scope.siteMarkers.push({
						id: customer.primary_site.id,
						geo: {
							latitude: customer.primary_site.lat,
							longitude: customer.primary_site.lng
						}
					});
					var point = new google.maps.LatLng(customer.primary_site.lat, customer.primary_site.lng);
					bounds.extend(point);
					customer.geocoded = true;
				}
				else {
					customer.geocoded = false;
				}
				$scope.customers.push(angular.copy(customer));
			});

			map.fitBounds(bounds);
			$scope.loading = false;
		});

		$scope.recordBlur = function (record) {
			record.selected = false;
		};

		$scope.recordClick = function (record) {
			// deselect all
			angular.forEach($scope.customers, function (value) {
				$scope.recordBlur(value);
			});
			// select this
			record.selected = true;
			// find and move to marker
			var markers = $filter('filter')($scope.siteMarkers, {
				id: record.primary_site.id
			}, true);
			if (angular.isArray(markers)) {
				angular.forEach(markers, function (marker) {
					var point = new google.maps.LatLng(marker.geo.latitude, marker.geo.longitude);
					var map = $scope.control.getGMap();
					map.panTo(point);
				});
			}
		};
	});

	uiGmapGoogleMapApi.then(function (maps) {
		$scope.map = {
			center: {
				latitude: 52,
				longitude: -1.0
			},
			zoom: 8,
			options: {
				panControlOptions: {
					position: maps.ControlPosition.RIGHT_TOP
				},
				zoomControlOptions: {
					position: maps.ControlPosition.RIGHT_TOP
				}
			}
		};
	});

});